'use strict';

import angular from 'angular';
import AddController from './add.controller';

export default angular.module('updateServerApp.firmwares.add', [])
    .controller('FirmwaresAddController', AddController)
    .name;



// WEBPACK FOOTER //
// ./client/app/firmwares/add/index.js